module.exports = __webpack_public_path__ + "img/result_bg_spot@2x.60346a34.png";